import React, { useState, useEffect } from "react";
import { Phone, Menu, X, MessageCircle, Building2, Download } from "lucide-react";
import { SITE } from "../mock";

const NAV = [
  { label: "Overview", href: "#overview" },
  { label: "Price", href: "#price" },
  { label: "Highlights", href: "#highlights" },
  { label: "Floor Plan", href: "#floorplan" },
  { label: "Amenities", href: "#amenities" },
  { label: "Site Visit", href: "#site-visit" },
  { label: "Gallery", href: "#gallery" },
  { label: "Location", href: "#location" },
  { label: "Contact", href: "#contact" },
];

export default function Header({ onEnquire }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <>
      {/* Top utility strip */}
      <div className="bg-[#2a1212] text-white text-xs py-1.5 px-4 hidden md:flex items-center justify-between">
        <div className="flex items-center gap-4">
          <span className="opacity-80">Site Visit Available • Book Your Slot Today</span>
        </div>
        <div className="flex items-center gap-4">
          <a href={`tel:${SITE.phoneRaw}`} className="flex items-center gap-1.5 hover:text-[#C9A24B] transition-colors">
            <Phone className="w-3 h-3" /> {SITE.phone}
          </a>
          <a href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 hover:text-[#C9A24B] transition-colors">
            <MessageCircle className="w-3 h-3" /> WhatsApp
          </a>
        </div>
      </div>

      <header className={`sticky top-0 z-40 transition-all duration-300 ${scrolled ? "bg-white shadow-md" : "bg-white/95 backdrop-blur"}`}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
          <a href="#top" className="flex items-center gap-3">
            <div className="w-11 h-11 bg-gradient-to-br from-[#8B1E1E] to-[#5a1212] rounded flex items-center justify-center text-[#C9A24B] shrink-0 shadow-sm">
              <Building2 className="w-5 h-5" strokeWidth={1.8} />
            </div>
            <div className="min-w-0">
              <div className="font-serif-display text-lg md:text-xl font-bold text-[#8B1E1E] leading-none whitespace-nowrap">Godrej Elaris</div>
              <div className="text-[10px] md:text-xs text-gray-500 leading-tight mt-1 truncate">Magarpatta–Mundhwa, Pune</div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-4 text-[13px] font-medium text-gray-700 whitespace-nowrap">
            {NAV.map((n) => (
              <a key={n.href} href={n.href} className="hover:text-[#8B1E1E] transition-colors">{n.label}</a>
            ))}
          </nav>

          <div className="flex items-center gap-2.5">
            <a href={`tel:${SITE.phoneRaw}`} className="hidden md:inline-flex items-center gap-1 text-[13px] font-semibold text-[#8B1E1E] hover:text-[#6f1616] whitespace-nowrap">
              <Phone className="w-3.5 h-3.5" /> {SITE.phone}
            </a>
            <button onClick={onEnquire} className="btn-gold hidden md:inline-flex text-[13px] px-3 py-2 whitespace-nowrap">
              <Download className="w-3.5 h-3.5" /> Download Brochure
            </button>
            <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-[#8B1E1E]" aria-label="menu">
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden bg-white border-t border-[#ecdfc9]">
            <div className="flex flex-col p-4 gap-3">
              {NAV.map((n) => (
                <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="text-gray-700 hover:text-[#8B1E1E] py-1">{n.label}</a>
              ))}
              <a href={`tel:${SITE.phoneRaw}`} className="btn-primary justify-center mt-2"><Phone className="w-4 h-4" /> {SITE.phone}</a>
            </div>
          </div>
        )}
      </header>

      {/* scrolling offer ticker */}
      <div className="bg-[#C9A24B] text-[#1a1a1a] text-xs md:text-sm py-1.5 overflow-hidden font-medium">
        <div className="ticker-track">
          {Array(2).fill(0).map((_, i) => (
            <div key={i} className="flex items-center gap-10 pr-10">
              <span>🏆 Pre-Launch Offer – Assured Gifts on Site Visit</span>
              <span>•</span>
              <span>💰 2 BHK Starting ₹ 1.47 Cr* Onwards</span>
              <span>•</span>
              <span>📞 Call {SITE.phone}</span>
              <span>•</span>
              <span>✨ Premium Retail Space Available</span>
              <span>•</span>
              <span>🚇 Prime Magarpatta Location</span>
              <span>•</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
